import React from 'react';
import { Facebook, Instagram, MapPin, Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-charcoal-900 text-cream-200 pt-16 pb-8" data-id="element-22">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-23">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-24">
          {/* Brand */}
          <div className="space-y-6" data-id="element-25">
            <img src="https://www.downhomeinteriors.com/uploaded/images/newresponsivesite/header/logo.png" alt="Down Home Interiors" className="h-12 w-auto brightness-0 invert opacity-90" data-id="element-26" />
            <p className="text-cream-200/70 text-sm leading-relaxed max-w-xs" data-id="element-27">
              Creating timeless, elegant spaces that feel like home.
              <br data-id="element-28" />
              <br data-id="element-29" />
              For design and remodeling projects, we invite you to call and
              speak directly with our owner.
            </p>
            <div className="flex items-center gap-4" data-id="element-30">
              <a href="https://www.facebook.com/DownTowneApparel/" target="_blank" rel="noopener noreferrer" className="text-cream-200 hover:text-sage-500 transition-colors" aria-label="Facebook" data-id="element-31">
                <Facebook size={20} data-id="element-32" />
              </a>
              <a href="https://www.instagram.com/downhomeinteriors/" target="_blank" rel="noopener noreferrer" className="text-cream-200 hover:text-sage-500 transition-colors" aria-label="Instagram" data-id="element-33">
                <Instagram size={20} data-id="element-34" />
              </a>
              <a href="https://www.google.com/search?sca_esv=4b9c4fb793c57767&sxsrf=ANbL-n78z7sdk_j7yEb4e4hHcP1NZBIjeg:1774386941928&si=AL3DRZHrmvnFAVQPOO2Bzhf8AX9KZZ6raUI_dT7DG_z0kV2_x3psb7CA-Nc1Cpwf94juoAWPOy8Jpg5zj8wtuCPoZQsvcG86tAImZn-aEPtfPcYRJ08C8rZSxS3BdYMXqFZGPTQ3qoF__a3YSAvJu0iWpjgIwoeHAg%3D%3D&q=Down+Home+Interiors+Reviews&sa=X&ved=2ahUKEwjJlfi6urmTAxWUmWoFHd2JNnoQ0bkNegQIJRAH#" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-cream-200/70 hover:text-sage-500 transition-colors text-sm" data-id="element-35">
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor" data-id="element-36">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-37" />
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-38" />
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-39" />
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-40" />
                </svg>
                Leave a Review
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-41">
            <h3 className="text-cream-100 font-serif text-lg mb-6" data-id="element-42">Explore</h3>
            <ul className="space-y-3" data-id="element-43">
              <li data-id="element-44">
                <Link to="/About.html" className="text-cream-200/70 hover:text-sage-500 transition-colors" data-id="element-45">
                  Our Story
                </Link>
              </li>
              <li data-id="element-46">
                <Link to="/interior-design-services" className="text-cream-200/70 hover:text-sage-500 transition-colors" data-id="element-47">
                  Services
                </Link>
              </li>
              <li data-id="element-48">
                <Link to="/Portfolio.html" className="text-cream-200/70 hover:text-sage-500 transition-colors" data-id="element-49">
                  Portfolio
                </Link>
              </li>
              <li data-id="element-50">
                <Link to="/Testimonials.html" className="text-cream-200/70 hover:text-sage-500 transition-colors" data-id="element-51">
                  Reviews
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-52">
            <h3 className="text-cream-100 font-serif text-lg mb-6" data-id="element-53">Contact</h3>
            <ul className="space-y-4" data-id="element-54">
              <li className="flex items-start space-x-3 text-cream-200/70" data-id="element-55">
                <MapPin size={18} className="mt-1 flex-shrink-0" data-id="element-56" />
                <a href="https://www.google.com/maps/search/?api=1&query=2729+E.+Grand+River+Ave.+Howell+MI+48843" target="_blank" rel="noopener noreferrer" className="hover:text-sage-500 transition-colors" data-id="element-57">
                  2729 E. Grand River Ave.
                  <br data-id="element-58" />
                  Howell, MI 48843
                </a>
              </li>
              <li className="flex items-center space-x-3 text-cream-200/70" data-id="element-59">
                <Phone size={18} data-id="element-60" />
                <a href="tel:5175455955" className="hover:text-sage-500 transition-colors" data-id="element-61">
                  (517) 545-5955
                </a>
              </li>
              <li className="flex items-center space-x-3 text-cream-200/70" data-id="element-62">
                <Mail size={18} data-id="element-63" />
                <a href="mailto:info@downhomeinteriors.com" className="hover:text-sage-500 transition-colors" data-id="element-64">
                  info@downhomeinteriors.com
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div data-id="element-65">
            <h3 className="text-cream-100 font-serif text-lg mb-6" data-id="element-66">
              Store Hours
            </h3>
            <ul className="space-y-2 text-cream-200/70" data-id="element-67">
              <li className="flex justify-between" data-id="element-68">
                <span data-id="element-69">Sunday</span>
                <span data-id="element-70">10:30am - 3:30pm</span>
              </li>
              <li className="flex justify-between" data-id="element-71">
                <span data-id="element-72">Monday</span>
                <span data-id="element-73">10am - 4pm</span>
              </li>
              <li className="flex justify-between" data-id="element-74">
                <span data-id="element-75">Tue - Thu</span>
                <span data-id="element-76">10am - 5:30pm</span>
              </li>
              <li className="flex justify-between" data-id="element-77">
                <span data-id="element-78">Friday</span>
                <span data-id="element-79">10am - 5pm</span>
              </li>
              <li className="flex justify-between" data-id="element-80">
                <span data-id="element-81">Saturday</span>
                <span data-id="element-82">Closed</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-charcoal-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-cream-200/40" data-id="element-83">
          <p data-id="element-84">
            &copy; {new Date().getFullYear()} Down Home Interiors. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-85">
            <span className="hover:text-cream-200 cursor-pointer" data-id="element-86">
              Privacy Policy
            </span>
            <span className="hover:text-cream-200 cursor-pointer" data-id="element-87">
              Terms of Service
            </span>
          </div>
        </div>
      </div>
    </footer>;
}